export const roles = {
  JOB_SEEKER: 'JOB_SEEKER',
  JOB_SUPERVISOR: 'JOB_SUPERVISOR',
  SUPER_ADMIN: 'SUPER_ADMIN',
  EMPLOYER_STAFF: 'EMPLOYER_STAFF',
  JOB_ADMIN: 'JOB_ADMIN',
  EMPLOYER_ADMIN: 'EMPLOYER_ADMIN',
  ON_BOARDING_STAFF: 'ON_BOARDING_STAFF',
  PERMISSION_USER: 'PERMISSION_USER',
  ENTERPRISE_ADMIN: 'ENTERPRISE_ADMIN',
  AGENCY_ADMIN: 'AGENCY_ADMIN',
  AGENCY_STAFF: 'AGENCY_STAFF',
  ENTERPRISE_STAFF: 'ENTERPRISE_STAFF',
  INTERNAL_ADMIN: 'INTERNAL_ADMIN',
  PERMISSION_ADMIN: 'PERMISSION_ADMIN',
  VENDOR_ADMIN: 'VENDOR_ADMIN',
  AGENT_ADMIN: 'AGENT_ADMIN',
  RM: 'RM'
};

/** Where a user whose role only works assigned leads lands, and the one screen they reach. */
export const MY_LEADS_ROUTE = '/job/my-leads';

export const entityTypes = {
  ADMIN: "ADMIN",
  ENTERPRISE: "ENTERPRISE",
  AGENCY: "AGENCY",
  VENDOR: "VENDOR",
  INTERNAL: "INTERNAL",
  PERMISSION: "PERMISSION",
  AGENT: "AGENT"
}

export const permissions = {
  // CREATE_BOOKING: 'CREATE_BOOKING',
  // ADD_VENDOR: 'ADD_VENDOR',
  // CREATE_PROJECT: 'CREATE_PROJECT',
  // ADD_AGENCY: 'ADD_AGENCY',
  // CREATE_ENTITY: 'CREATE_ENTITY',
  // CREATE_USER: 'CREATE_USER',

  DASHBOARD_VIEW: 'DASHBOARD_VIEW',
  DASHBOARD_EDIT: 'DASHBOARD_EDIT',
  DASHBOARD_CREATE: 'DASHBOARD_CREATE',
  DASHBOARD_DELETE: 'DASHBOARD_DELETE',

  PROJECT_VIEW: 'PROJECT_VIEW',
  PROJECT_EDIT: 'PROJECT_EDIT',
  PROJECT_CREATE: 'PROJECT_CREATE',
  PROJECT_DELETE: 'PROJECT_DELETE',

  QUOTATION_VIEW: 'QUOTATION_VIEW',
  QUOTATION_CREATE: 'QUOTATION_CREATE',
  QUOTATION_EDIT: 'QUOTATION_EDIT',
  QUOTATION_DELETE: 'QUOTATION_DELETE',

  PO_VIEW: 'PO_VIEW',
  PO_CREATE: 'PO_CREATE',
  PO_EDIT: 'PO_EDIT',
  PO_DELETE: 'PO_DELETE',

  BILLING_VIEW: 'BILLING_VIEW',
  BILLING_CREATE: 'BILLING_CREATE',
  BILLING_EDIT: 'BILLING_EDIT',
  BILLING_DELETE: 'BILLING_DELETE',

  WORKORDER_VIEW: 'WORKORDER_VIEW',
  WORKORDER_CREATE: 'WORKORDER_CREATE',
  WORKORDER_EDIT: 'WORKORDER_EDIT',
  WORKORDER_DELETE: 'WORKORDER_DELETE',

  VENUES_VIEW: 'VENUES_VIEW',
  VENUES_CREATE: 'VENUES_CREATE',
  VENUES_EDIT: 'VENUES_EDIT',
  VENUES_DELETE: 'VENUES_DELETE',

  BOOKINGS_VIEW: 'BOOKINGS_VIEW',
  BOOKINGS_CREATE: 'BOOKINGS_CREATE',
  BOOKINGS_EDIT: 'BOOKINGS_EDIT',
  BOOKINGS_DELETE: 'BOOKINGS_DELETE',

  MEMBERS_AND_ROLES_VIEW: 'MEMBERS_AND_ROLES_VIEW',
  MEMBERS_AND_ROLES_CREATE: 'MEMBERS_AND_ROLES_CREATE',
  MEMBERS_AND_ROLES_EDIT: 'MEMBERS_AND_ROLES_EDIT',
  MEMBERS_AND_ROLES_DELETE: 'MEMBERS_AND_ROLES_DELETE',

  CREDITS_VIEW: 'CREDITS_VIEW',
  CREDITS_CREATE: 'CREDITS_CREATE',
  CREDITS_EDIT: 'CREDITS_EDIT',
  CREDITS_DELETE: 'CREDITS_DELETE',

  SUBSCRIPTIONS_VIEW: 'SUBSCRIPTIONS_VIEW',
  SUBSCRIPTIONS_CREATE: 'SUBSCRIPTIONS_CREATE',
  SUBSCRIPTIONS_EDIT: 'SUBSCRIPTIONS_EDIT',
  SUBSCRIPTIONS_DELETE: 'SUBSCRIPTIONS_DELETE',

  USERS_VIEW: 'USERS_VIEW',
  USERS_CREATE: 'USERS_CREATE',
  USERS_EDIT: 'USERS_EDIT',
  USERS_DELETE: 'USERS_DELETE',

  AGENCIES_VIEW: 'AGENCIES_VIEW',
  AGENCIES_CREATE: 'AGENCIES_CREATE',
  AGENCIES_EDIT: 'AGENCIES_EDIT',
  AGENCIES_DELETE: 'AGENCIES_DELETE',

  TEAM_MEMBERS_VIEW: 'TEAM_MEMBERS_VIEW',
  TEAM_MEMBERS_CREATE: 'TEAM_MEMBERS_CREATE',
  TEAM_MEMBERS_EDIT: 'TEAM_MEMBERS_EDIT',
  TEAM_MEMBERS_DELETE: 'TEAM_MEMBERS_DELETE',

  VENDORS_VIEW: 'VENDORS_VIEW',
  VENDORS_CREATE: 'VENDORS_CREATE',
  VENDORS_EDIT: 'VENDORS_EDIT',
  VENDORS_DELETE: 'VENDORS_DELETE',

  CHAMPS_VIEW: 'CHAMPS_VIEW',
  CHAMPS_CREATE: 'CHAMPS_CREATE',
  CHAMPS_EDIT: 'CHAMPS_EDIT',
  CHAMPS_DELETE: 'CHAMPS_DELETE',

  ENTERPRISES_VIEW: 'ENTERPRISES_VIEW',
  ENTERPRISES_CREATE: 'ENTERPRISES_CREATE',
  ENTERPRISES_EDIT: 'ENTERPRISES_EDIT',
  ENTERPRISES_DELETE: 'ENTERPRISES_DELETE',

  PERMISSION_USERS_VIEW: 'PERMISSION_USERS_VIEW',
  PERMISSION_USERS_CREATE: 'PERMISSION_USERS_CREATE',
  PERMISSION_USERS_EDIT: 'PERMISSION_USERS_EDIT',
  PERMISSION_USERS_DELETE: 'PERMISSION_USERS_DELETE',

  DIGITAL_PORTFOLIO_VIEW: 'DIGITAL_PORTFOLIO_VIEW',
  DIGITAL_PORTFOLIO_CREATE: 'DIGITAL_PORTFOLIO_CREATE',
  DIGITAL_PORTFOLIO_EDIT: 'DIGITAL_PORTFOLIO_EDIT',
  DIGITAL_PORTFOLIO_DELETE: 'DIGITAL_PORTFOLIO_DELETE',

  SETTINGS_VIEW: 'SETTINGS_VIEW',
  SETTINGS_CREATE: 'SETTINGS_CREATE',
  SETTINGS_EDIT: 'SETTINGS_EDIT',
  SETTINGS_DELETE: 'SETTINGS_DELETE',

  APPROVE_CANDIDATES_IN_SHIFTS_VIEW: 'APPROVE_CANDIDATES_IN_SHIFTS_VIEW',
  APPROVE_CANDIDATES_IN_SHIFTS_CREATE: 'APPROVE_CANDIDATES_IN_SHIFTS_CREATE',
  APPROVE_CANDIDATES_IN_SHIFTS_EDIT: 'APPROVE_CANDIDATES_IN_SHIFTS_EDIT',
  APPROVE_CANDIDATES_IN_SHIFTS_DELETE: 'APPROVE_CANDIDATES_IN_SHIFTS_DELETE',

  AGENTS_VIEW: 'AGENTS_VIEW',
  AGENTS_CREATE: 'AGENTS_CREATE',
  AGENTS_EDIT: 'AGENTS_EDIT',
  AGENTS_DELETE: 'AGENTS_DELETE',

  REFERRAL_VIEW: 'REFERRAL_VIEW',
  REFERRAL_CREATE: 'REFERRAL_CREATE',
  REFERRAL_EDIT: 'REFERRAL_EDIT',
  REFERRAL_DELETE: 'REFERRAL_DELETE',

  // View-only: a user works the leads assigned to them, so there is nothing to
  // create, edit or delete from the menu's point of view.
  //
  // The value is deliberately not underscored between MY and LEADS. A granted
  // permission string is `<permissionName>_<ACTION>`, and the backend created
  // this one with permissionName 'MY LEADS' — space and all. add-edit-roles
  // splits on the LAST underscore, so it round-trips, but the space means the
  // usual toUpperCase().replaceAll(' ', '_') form ('MY_LEADS_VIEW') will NOT
  // match. Keep this string byte-for-byte in step with the backend record.
  MY_LEADS_VIEW: 'MY LEADS_VIEW',
};

/** Every granted permission string. The account nests them one level deep. */
function grantedPermissions(account: any): string[] {
  const raw = (account && account.permissions) || [];
  return raw.reduce((all: string[], entry: any) => all.concat(entry || []), []);
}

/**
 * True for an account that may work its assigned leads and nothing else.
 *
 * Asked as a permission rather than a role name. This used to compare against
 * 'RM'; the role was then renamed to 'Relationship Manager', which silently
 * unfenced those accounts — they kept their menu entry but the guard stopped
 * recognising them and bounced them off /job/my-leads to the dashboard.
 *
 * MY_LEADS_VIEW alone cannot answer this: an admin granted it must keep the
 * rest of the product. What separates the two is PROJECT_VIEW, which every
 * account that works beyond its own leads already holds.
 */
export function isAssignedLeadsOnlyAccount(account: any): boolean {
  const granted = grantedPermissions(account);
  return granted.indexOf(permissions.MY_LEADS_VIEW) !== -1
    && granted.indexOf(permissions.PROJECT_VIEW) === -1;
}
